import { Component } from "react";
import "./../search.css";
import "./SearchInputWithSuggestions.css";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import Input from "./../../formElements/Input/Input";
import Action from "./../../formElements/Action/Action";
import { DICTIONARY_OBJ } from "model/dictionary";
import searchImg from "./../../../images/search.svg";
import dropdownImg from "./images/dropdown.svg";
import { Translation } from "react-i18next";

const SEARCH_PLACEHOLDER = "Tool.lookUp";

export default class SearchInputWithSuggestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: this.props.suggestions,
      isSuggestionsContainerOpened: false,
      isFocused: false,
    };

    this.getSuggestions = this.getSuggestions.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderInputComponent = this.renderInputComponent.bind(this);
    this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
    this.onArrowClick = this.onArrowClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.storeInputReference = this.storeInputReference.bind(this);
  }

  onChange(event, { newValue }) {
    this.props.onValueChanged(newValue);
    if (!this.state.isSuggestionsContainerOpened) {
      this.setState({ isSuggestionsContainerOpened: true });
    }
  }

  getSuggestionValue(suggestion) {
    return suggestion;
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  getSuggestions(value) {
    // Teach Autosuggest how to calculate suggestions for any given input value.
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? this.props.suggestions
      : this.props.suggestions.filter(
          op => op.toLowerCase().slice(0, inputLength) === inputValue
        );
  }

  renderSuggestion(suggestion) {
    return <div className="suggestion">{suggestion}</div>;
  }

  onArrowClick() {
    const shouldBeOpened = !this.state.isSuggestionsContainerOpened === true;
    this.setState({
      isSuggestionsContainerOpened: !this.state.isSuggestionsContainerOpened,
      suggestions: this.getSuggestions(this.props.value),
    });
    if (shouldBeOpened) {
      this.searchInput && this.searchInput.focus();
    } else {
      this.searchInput && this.searchInput.blur();
    }
  }

  closeSuggestions() {
    this.setState({ isSuggestionsContainerOpened: false, isFocused: false });
  }

  onSearchClick() {
    this.closeSuggestions();
    this.props.onSearch();
  }

  onKeyPress(evt) {
    if (evt.key === "Enter") {
      // Proceed to search after click on Enter.
      this.onSearchClick();
    }
  }

  onSuggestionSelected(event, { suggestionValue }) {
    if (suggestionValue) {
      this.closeSuggestions();
      this.props.onSearch(suggestionValue);
    }
  }

  renderInputComponent(inputProps) {
    return (
      <div>
        <Input
          {...inputProps}
          maxLength={DICTIONARY_OBJ.text.maxLength}
          onKeyPress={this.onKeyPress}
        />
        <div className="input-actions-container">
          <Action className="dropdown-btn" onClick={this.onArrowClick}>
            <img src={dropdownImg} alt="dropdown" />
          </Action>
          <Action className="search-btn" onClick={this.onSearchClick}>
            <img src={searchImg} alt="search" />
          </Action>
        </div>
      </div>
    );
  }

  renderSuggestionsContainer({ containerProps, children }) {
    if (!this.state.isSuggestionsContainerOpened && !this.state.isFocused) {
      return null;
    }
    return <div {...containerProps}>{children}</div>;
  }

  onFocus() {
    this.setState({ isFocused: true });
  }

  onBlur() {
    this.setState({ isFocused: false });
  }

  storeInputReference(autosuggest) {
    if (autosuggest !== null) {
      this.searchInput = autosuggest.input;
    }
  }

  render() {
    const { suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      value: this.props.value,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    };

    return (
      <Translation>
        {t => (
          <Autosuggest
            className="search-input"
            suggestions={suggestions}
            alwaysRenderSuggestions={true}
            highlightFirstSuggestion={true}
            getSuggestionValue={this.getSuggestionValue}
            focusInputOnSuggestionClick={false}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionSelected={this.onSuggestionSelected}
            renderSuggestion={this.renderSuggestion}
            renderInputComponent={this.renderInputComponent}
            renderSuggestionsContainer={this.renderSuggestionsContainer}
            inputProps={{ ...inputProps, placeholder: t(SEARCH_PLACEHOLDER) }}
            ref={this.storeInputReference}
          />
        )}
      </Translation>
    );
  }
}

SearchInputWithSuggestions.propTypes = {
  value: PropTypes.string,
  onSearch: PropTypes.func,
  onValueChanged: PropTypes.func,
};
